import {changeNestedValue} from "@Common/utils/arr-path";
import {chain}             from "@Common/utils/fs";

export const itemEditor = (m1, total) => !m1.module?.itemEditor ? total : changeNestedValue(total, ["itemEditors"], (_) => [
    ..._??[],
    m1.module.itemEditor,
]);

export const cleanItem = (m1, total) => !m1.module?.cleanItem ? (
    total
) : changeNestedValue(total, ["cleanItem"], (_) => (
    !_ ? (
        m1.module.cleanItem
    ) : (
        (item) => chain(
            item,
            _,
            m1.module.cleanItem,
        )
    )
));

export const ui = (name=undefined) => (m1, total) => !m1.module?.ui ? total : changeNestedValue(total, ["ui"], (_) => ({
    ..._,
    [name ?? m1.feed.name]: m1.module.ui,
}));



